'use client';

import { FC } from 'react';

import { AssetUtils } from '@ravago/shared/next-data-access';
import { ElementProps } from '@ravago/shared/page-data/models/base';
import { NormalizedProduct } from '@ravago/shared/page-data/models/contentful-mapped';
import { ProductHeaderNode } from '@ravago/shared/page-data/models/elements';

import { AvatarNameHeader } from '../../shared/avatar-name-header/avatar-name-header';

export const ProductHeaderElement: FC<ElementProps<ProductHeaderNode>> = ({ node, globals }) => {
   const product = globals.contentEntity as NormalizedProduct;

   if (!product) return null;

   return (
      <AvatarNameHeader
         theme={node.theme === 'primary' ? 'primary' : 'inverse-strong'}
         avatar={
            product.brand.producer?.logo?.url ? AssetUtils.optimizeImageIfRequired(product.brand.producer.logo.url, globals.acceptWebp) : undefined
         }
         name={product.name}
      />
   );
};
